import { unionBy } from 'lodash';
import Actions from '../actions/actions';
import CampaignsActions from '../actions/CampaignsCRUDActions';
import { Campaigns } from '../interfaces/campaigns';
import { CampaignType } from '../model/CampaignsModel';
import { setBusy, setUnBusy, update } from './common/commonReducers';

const initialState: Campaigns = {
  busy: false,
  entities: [],
  // This does not seem right but don't want to change in case of bugs
  // @ts-ignore
  pagination: {},
  errors: [],
  queuedContacts: {},
  trackings: {
    // This does not seem right but don't want to change in case of bugs
    // @ts-ignore
    pagination: {},
    // This does not seem right but don't want to change in case of bugs
    // @ts-ignore
    trackings: {},
  },
};

const modifyQueuedContacts = (
  entities: CampaignType[],
  schedulerId: number,
  queuedCount?: number,
) => {
  if (queuedCount === undefined) {
    return entities;
  }
  const campaignIndex = entities.findIndex(c =>
    c.schedulersAttributes?.find(s => s.id === schedulerId),
  );
  const schedulerIndex = entities[
    campaignIndex
  ]?.schedulersAttributes?.findIndex(s => s.id === schedulerId);
  if (campaignIndex === -1) {
    return entities;
  }
  // at this point we know both campaign and scheduler should be there, so casting is safe
  const campaign = entities[campaignIndex];
  const scheduler = {
    ...campaign.schedulersAttributes?.[schedulerIndex as number],
    currentQueuedCount: queuedCount || 0,
  };
  const modifiedCampaign = {
    ...campaign,
    schedulersAttributes: Object.assign(
      [...(campaign.schedulersAttributes || [])],
      {
        [schedulerIndex as number]: scheduler,
      },
    ),
  };
  return Object.assign([...entities], { [campaignIndex]: modifiedCampaign });
};

export default function forms(state = initialState, action) {
  switch (action.type) {
    case CampaignsActions.busyAction:
      return setBusy(state);
    case CampaignsActions.retrievedAllAction: {
      const { entities } = action;
      return {
        ...state,
        busy: false,
        entities: unionBy(state.entities, entities.campaigns, 'id'),
        pagination: entities.pagination,
      };
    }

    case CampaignsActions.updateSuccessAction: {
      return update(state, action);
    }

    case CampaignsActions.fetchedQueuedContactsAction: {
      const { contacts, schedulerId } = action;
      const modifiedEntities = modifyQueuedContacts(
        state.entities,
        schedulerId,
        contacts.pagination.total,
      );

      return {
        ...state,
        busy: false,
        entities: modifiedEntities,
        queuedContacts: {
          ...state.queuedContacts,
          [schedulerId]: { ...contacts },
        },
      };
    }
    case CampaignsActions.retrievedAction: {
      return update(state, action);
    }
    case CampaignsActions.deleteLocalAction: {
      const { campaignId } = action;
      const entities = state.entities.filter(
        campaign => campaign.id !== campaignId,
      );
      return {
        ...state,
        busy: false,
        entities,
      };
    }
    case CampaignsActions.setErrorStatus: {
      const { errorMessages } = action;
      return {
        ...state,
        busy: false,
        errors: errorMessages,
      };
    }
    case CampaignsActions.setCampaignTrackingAction: {
      const { trackings } = action;
      return {
        ...state,
        busy: false,
        trackings,
      };
    }

    case Actions.UNBUSY:
      return setUnBusy(state);
    case CampaignsActions.unbusyAction:
      return setUnBusy(state);
    case Actions.RESET:
      return initialState;
    case CampaignsActions.resetAction:
      return initialState;
    default:
      return state;
  }
}
